import {
  Box,
  Flex,
  HStack,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  VStack,
} from "@chakra-ui/react";
import React from "react";

const CarouselSkeleton = () => {
  return (
    <Box
      position={"relative"}
      overflow={"hidden"}
      rounded={{
        base: "12px",
        sm: "14px",
        md: "14px",
        lg: "16px",
        xl: "16px",
        "2xl": "18px",
        "3xl": "20px",
        "4xl": "24px",
        "5xl": "32px",
      }}
      border={"solid 0.1px #D9D9D9"}
    >
      <Box position="relative" overflow="hidden" h="584px" mx="auto">
        {/* Skeleton for Text and Button */}
        <Flex
          as="div"
          maxW="100%"
          px={{ base: "30px", md: "40px", lg: "70px" }}
          flexDirection={{ base: "column", xl: "row" }}
          h="full"
          alignItems="start"
          justifyContent={{ base: "center", xl: "space-between" }}
          gap="16px"
          py="78px"
        >
          <VStack
            gap={{ base: "20px", xl: "40px" }}
            color="white"
            justifyContent="start"
            padding={{ base: "10px 15px", xl: "20px 30px" }}
            alignItems="start"
            rounded={"md"}
            w={"full"}
            maxW={"750px"}
            background={"blackAlpha.200"}
          >
            {/* Skeleton for Title and Subtitle */}
            <SkeletonText noOfLines={1} width="70%" />
            <SkeletonText noOfLines={5} width="90%" />

            {/* Skeleton for Button */}
            <Skeleton height="40px" width="150px" rounded="md" />
          </VStack>

          {/* Skeleton for Side Image */}
          <Flex
            alignItems="flex-end"
            justifyContent="flex-end"
            flex="none"
            mx="auto"
            h={{
              base: "246px",
              sm: "280px",
              md: "320px",
              lg: "360px",
              xl: "full",
              "2xl": "full",
              "3xl": "full",
            }}
            w={{
              base: "163px",
              sm: "200px",
              md: "250px",
              lg: "300px",
              xl: "335px",
              "2xl": "400px",
              "3xl": "450px",
            }}
          >
            <Skeleton h="full" w="full" />
          </Flex>
        </Flex>

        {/* Skeleton for Arrows Navigation */}
        <Skeleton
          size="10"
          position="absolute"
          top="50%"
          left={{ base: "1", xl: "4" }}
          transform="translateY(-50%)"
          bg="blackAlpha.600"
          w={"60px"}
          h={"40px"}
          mt={"20px"}
          rounded={"md"}
        />
        <Skeleton
          size="10"
          position="absolute"
          top="50%"
          right={{ base: "1", xl: "4" }}
          transform="translateY(-50%)"
          bg="blackAlpha.600"
          w={"60px"}
          h={"40px"}
          mt={"20px"}
          rounded={"md"}
        />

        {/* Skeleton for Dots Navigation */}
        <HStack
          position="absolute"
          bottom="4"
          left="50%"
          transform="translateX(-50%)"
          spacing={2}
        >
          {[...Array(3)].map((_, index) => (
            <SkeletonCircle key={index} size="4" />
          ))}
        </HStack>
      </Box>
    </Box>
  );
};

export default CarouselSkeleton;
